import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ParentappLoginComponent } from './parentapp-login/parentapp-login.component';
import { ProgressReportPageComponent } from './progress-report-page/progress-report-page.component';
import { authGuard } from './auth.guard';
import { RegistrationUserComponent } from './registration-user/registration-user.component';
import { EmployeeStudentProgressReportComponent } from './employee-student-progress-report/employee-student-progress-report.component';
import { ParentappStudentProgressReportComponent } from './parentapp-student-progress-report/parentapp-student-progress-report.component';
import { StudentProgressReportComponent } from './student-progress-report/student-progress-report.component';
const routes: Routes = [

  {
   path: 'parent',
   children:[
    {
      path: 'login', component: ParentappLoginComponent,
    },
    { path: 'studentProgressReport', component: ParentappStudentProgressReportComponent, canActivate: [authGuard] },
    { path: 'progressReport', component: EmployeeStudentProgressReportComponent},
    { path: 'parent', redirectTo: 'parent/login', pathMatch: 'full' },
    { path: 'registration', component: RegistrationUserComponent }
   ]
  },
   { path: 'progressReport', component: EmployeeStudentProgressReportComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParentAppRoutingModule { }
